export const academyTeamName = (group) => {
  const age = `${group?.name || ""} ${group?.age_range || ""}`.match(/\bU\s*-?\s*(\d{1,2})\b/i);
  return age ? `ΛΕΥΤΕΡΙΑ U${age[1]}` : `ΛΕΥΤΕΡΙΑ ${group?.name || ""}`.trim();
};

export const isLefteriaHome = (fixture) => typeof fixture.is_home === "boolean" ? fixture.is_home : /LEFTERIA|ΛΕΥΤΕΡΙΑ/i.test((fixture.home_team || "").normalize("NFD").replace(/[\u0300-\u036f]/g, ""));

export const newAcademyFixture = (group, season) => ({
  home_team: academyTeamName(group), away_team: "", away_team_logo: "",
  match_date: "", match_time: "", arrival_time: "", venue: "", venue_id: "",
  location_url: "", competition: "Φιλικός Αγώνας", match_type: "friendly",
  is_home: true, opponent_id: "", season: season || "",
});